<ion-content force-overscroll="false" class="splash-screen">
  <div style="display: flex; justify-content: center; align-items: center; height: 100vh;">
    <img
      src="assets/img/logo_texto_branco.webp"
      width="130"
      height="130"
      fetchpriority="high"
      decoding="async"
      style="display: block;"
      alt="Logo do aplicativo"
    />
  </div>
</ion-content>
